import { Link, SxProps, Theme } from '@mui/material';
import ReactMarkdown from 'react-markdown';

export const MarkdownMessage = ({ children }: { children: string }) => {
  // Filter out [some string](careerpath:ID) patterns and remove parentheses from career path names
  const filteredContent = children.replace(/\[([^\]]+)\]\(careerpath:\d+\)/g, '$1');

  return (
    <ReactMarkdown
      components={{
        a: ({ href, children }) => (
          <Link href={href} target="_blank" rel="noopener noreferrer" sx={linkStyle}>
            {children}
          </Link>
        ),
      }}
    >
      {filteredContent}
    </ReactMarkdown>
  );
};

const linkStyle: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Blue/500'],
  fontWeight: 'bold',
});
